/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_New_UsersInputs */

const en_admin_statistics_new_users = /** @type {(inputs: Admin_Statistics_New_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Newly registered users`)
};

const de_admin_statistics_new_users = /** @type {(inputs: Admin_Statistics_New_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu registrierte Nutzer`)
};

/**
* | output |
* | --- |
* | "Newly registered users" |
*
* @param {Admin_Statistics_New_UsersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_new_users = /** @type {((inputs?: Admin_Statistics_New_UsersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_New_UsersInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_new_users(inputs)
	return en_admin_statistics_new_users(inputs)
});